
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/healers/[slug]/slots",
      function () {
        return require("private-next-pages/healers/[slug]/slots.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/healers/[slug]/slots"])
      });
    }
  